// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3ogZy","row":"Node_row__18v-7","label":"Node_label__ta66c","footer":"Node_footer__3JwMT"};